import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '主题索引', href: '#index' },
  { label: '媒体聚焦', href: '#media' },
  { label: '吃瓜精选', href: '#cards' },
  { label: '关于我们', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between h-16 md:h-[72px] px-4 md:px-6 max-w-[1280px]">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 no-underline cursor-pointer"
        >
          <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-global-line text-background-50 text-lg"></i>
          </span>
          <span className="text-lg md:text-xl font-heading font-bold text-foreground-100 whitespace-nowrap">
            在线吃瓜
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="px-4 py-2 text-sm font-medium text-foreground-300 hover:text-foreground-100 rounded-lg hover:bg-background-200/70 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-100 hover:bg-background-200/70 transition-colors cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-300/40 px-4 pb-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="block px-4 py-3 text-sm font-medium text-foreground-300 hover:text-foreground-100 hover:bg-background-200/70 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}